import * as Cookies from 'js-cookie';
import whenDomReady from 'when-dom-ready';
const COOKIE_NAME = 'xperience.cookielevelselection';
function initialise() {
    const cookieBar = document.querySelector('.js-xpcookiebanner');
    const hasBeenClosed = Cookies.get(COOKIE_NAME) === 'true';
    if (!cookieBar || hasBeenClosed) {
        return;
    }
    const cookieBarCtas = document.querySelectorAll('.js-close-cookie');
    const header = document.querySelector('.js-header');
    cookieBarCtas.forEach(function (elem) {
        elem.addEventListener('click', () => {
            cookieBar.classList.remove('is-active');
            header.classList.remove('js-header--xpcookiebanner-is-active');
        });
    });
}
whenDomReady().then(initialise);
